import { boot } from 'quasar/wrappers'
import VueRecaptcha from 'vue3-recaptcha2'

export default boot(({ app }) => {
  app.component('VueRecaptcha', VueRecaptcha)
})
